import React from "react";
import styled from "styled-components";
import NanoFlex from "../Global/NanoFlex.js";

const StyledSimpleButton = styled(NanoFlex)`
  height: auto;
  width: auto;
  margin: 0px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;

  .buttonWrapper {
    display: flex;
    width: auto;
    overflow: hidden;
    border-radius: 50px;
    padding: 12px 24px;
    background-color: ${(props) =>
      props.disabled
        ? props.theme.color.primaryColors.btnColors.purpleDisabled
        : props.darkPurple
        ? props.theme.color.primaryColors.btnColors.purpleDefault
        : props.lightPurple
        ? props.theme.color.primaryColors.btnColors.lightPurple
        : props.yellow
        ? props.theme.color.primaryColors.btnColors.yellowDefault
        : props.theme.color.primaryColors.labelPurple};
    font-family: ${(props) => props.theme.font};
    color: ${(props) => (props.yellow ? props.theme.color.primaryColors.darkPurple : props.lightPurple ? props.theme.color.primaryColors.darkPurple : props.theme.color.primaryColors.white)};
    transition: 0.4s all ease-in-out;
    cursor: pointer;
    border: none;
    outline: none;
    font-size: 18px;
    user-select: none;
    font-weight: normal !important;

    /* MEDIA QUERIES */

    @media only screen and (max-width: 1450px) {
      padding: 8px 20px;
      font-size: 14px;
    }

    @media only screen and (max-width: 1024px) {
      padding: 6px 12px;
      font-size: 12px;
    }

    &:hover {
      color: ${(props) => (props.lightPurple ? props.theme.color.primaryColors.darkPurple : props.yellow ? props.theme.color.primaryColors.labelPurple : props.theme.color.primaryColors.white)};
      background-color: ${(props) =>
        props.disabled
          ? props.theme.color.primaryColors.btnColors.purpleDisabled
          : props.lightPurple
          ? props.theme.color.primaryColors.btnColors.lightPurple
          : props.darkPurple
          ? props.theme.color.primaryColors.btnColors.purpleHover
          : props.yellow
          ? props.theme.color.primaryColors.btnColors.yellowHover
          : props.theme.color.primaryColors.btnColors.purpleHover};
    }

    &:focus,
    &:focus-visible {
      background-color: ${(props) =>
        props.disabled ? props.theme.color.primaryColors.btnColors.purpleDisabled : props.darkPurple ? props.theme.color.primaryColors.btnColors.purpleFocus : props.yellow ? props.theme.color.primaryColors.btnColors.yellowFocus : props.theme.color.primaryColors.btnColors.purpleFocus};
      border: none;
      outline: none;
    }

    &:active {
      background-color: ${(props) =>
        props.disabled
          ? props.theme.color.primaryColors.btnColors.purpleDisabled
          : props.darkPurple
          ? props.theme.color.primaryColors.btnColors.purpleActive
          : props.yellow
          ? props.theme.color.primaryColors.btnColors.yellowActive
          : props.lightPurple
          ? props.theme.color.primaryColors.btnColors.lightPurple
          : props.theme.color.primaryColors.btnColors.purpleActive};
      border: none;
      outline: none;
    }

    &:disabled,
    &.disabled {
      background-color: rgba(85, 106, 235, 0.4);
      cursor: default;
      pointer-events: none;
    }
    &:hover {
      opacity: 0.8;
    }
    &:focus {
      outline: 0;
    }
  }

  /* MEDIA QUERIES */

  @media only screen and (max-width: 1450px) {
    .buttonWrapper {
      padding: 8px 20px;
      font-size: 14px;
    }
  }

  @media only screen and (max-width: 1024px) {
    .buttonWrapper {
      padding: 6px 12px;
      font-size: 12px;
    }
  }
`;

const SimpleButton = (props) => {
  return (
    <StyledSimpleButton className="button" lightPurple={props.lightPurple} darkPurple={props.darkPurple} yellow={props.yellow} disabled={props.disabled}>
      <button className={`buttonWrapper ${props.disabled ? "disabled" : ""}`} type={props.type} onClick={() => props.clickAction(props.id)}>
        {props.label}
      </button>
    </StyledSimpleButton>
  );
};

// Set default props
SimpleButton.defaultProps = {
  id: 0,
  label: "",
  type: "submit",

  clickAction: () => null,
};

export default SimpleButton;
